import React from 'react';
import { formaterPrix } from '../../utils/formatPrix';

export interface DatesAvisNia {
  date_analyse: string;
  cours_a_la_date: number | null;
  derniere_valorisation: string | null;
  a_jour: boolean;
}

const enClair = (iso: string): string =>
  new Date(`${iso}T00:00:00`)
    .toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
    .replace(/^1 /, '1er ');

/**
 * Date de « L'avis de Nia ». Le texte est généré une fois par séance : sans cette ligne, un avis
 * rédigé sur un cours antérieur ne se distingue pas d'un avis du jour, et ses chiffres semblent
 * contredire l'onglet Indice Valeur (audit du 2026-10-01, B18).
 */
const DateAvisNia: React.FC<{ dates: DatesAvisNia | null }> = ({ dates }) => {
  if (!dates) return null;
  return (
    <div style={{ marginBottom: '18px', fontSize: '14px' }}>
      <p style={{ margin: 0, color: 'var(--text-muted)' }}>
        Analyse du <strong>{enClair(dates.date_analyse)}</strong>
        {dates.cours_a_la_date !== null && <>, au cours de <strong>{formaterPrix(dates.cours_a_la_date)} FCFA</strong></>}.
      </p>
      {!dates.a_jour && dates.derniere_valorisation && (
        <p
          role='status'
          style={{
            margin: '10px 0 0',
            padding: '10px 14px',
            borderRadius: '8px',
            background: 'rgba(245, 158, 11, 0.12)',
            border: '1px solid rgba(245, 158, 11, 0.4)',
            color: 'var(--text-main)',
          }}
        >
          L'onglet Indice Valeur affiche une valorisation plus récente, du {enClair(dates.derniere_valorisation)}.
          Les chiffres cités dans ce texte peuvent donc en différer.
        </p>
      )}
    </div>
  );
};

export default DateAvisNia;
